import * as z from 'zod';

export const EMAIL_SCHEMA = z
  .string()
  .trim()
  .toLowerCase()
  .email({ message: 'Enter a valid email address.' });

const TICKET_REFERENCE_MAX_LENGTH = 200;
const TICKET_REFERENCE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_./#:?&=%~+-]*$/;

export const REASON_SCHEMA = z
  .string()
  .trim()
  .min(1, { message: 'Add a ticket number or link' })
  .max(TICKET_REFERENCE_MAX_LENGTH, { message: 'Use a shorter ticket number or link' })
  .regex(TICKET_REFERENCE_PATTERN, {
    message: 'Enter only a ticket number or link, with no spaces. Keep details in the ticket.',
  });
